class ServiceResponseSuccess<T = any> {
  data: T;

  constructor(data: T) {
    this.data = data;
  }
}

export default ServiceResponseSuccess;